import { BEFORE_AFTER } from "../../lib/content";
import { CompareSlider } from "./CompareSlider";
import { Reveal } from "./Reveal";

export const BeforeAfter = () => (
  <section id="avant-apres" data-testid="before-after-section" className="scroll-mt-20 border-t border-cs-navy/5 bg-white py-20 md:py-28">
    <div className="mx-auto max-w-6xl px-5 sm:px-8">
      <Reveal className="mb-12 flex flex-col gap-4 md:mb-16 md:flex-row md:items-end md:justify-between">
        <div className="max-w-2xl">
          <span className="eyebrow">Résultats concrets</span>
          <h2 className="section-title">Avant / Après</h2>
        </div>
        <p className="max-w-sm text-[15px] text-cs-ink/70">Faites glisser le curseur pour comparer l'état du lieu avant et après notre passage.</p>
      </Reveal>
      <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-3 lg:gap-8">
        {BEFORE_AFTER.map((b, i) => (
          <Reveal key={b.title} delay={i * 0.08} as="figure" data-testid={`before-after-item-${i + 1}`} className={i === 2 ? "md:col-span-2 lg:col-span-1" : ""}>
            <CompareSlider before={b.before} after={b.after} alt={b.title} testId={`compare-slider-${i + 1}`} />
            <figcaption className="mt-4">
              <h3 className="font-display text-lg font-bold tracking-tight text-cs-navy">{b.title}</h3>
              <p className="mt-1 text-[15px] leading-relaxed text-cs-ink/70">{b.caption}</p>
            </figcaption>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
